var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ServiceBase, ServiceEndPoints } from "@/modules/services/models/ServiceBase";
import { DocumentList } from "../models/DocumentList";
import { PublicDocument } from "../models/PublicDocument";
var DocumentServices = (function (_super) {
    __extends(DocumentServices, _super);
    function DocumentServices() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentServices.prototype.getAllUserDocumentList = function () {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'GetCandidateCertificates', {}, null, new DocumentList());
    };
    DocumentServices.prototype.getUserPublicDocument = function (documentId) {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'GetSmartCertificateDetailsByQueryString', {
            QueryString: documentId
        }, null, new PublicDocument());
    };
    DocumentServices.prototype.getPublicUserDocumentList = function () {
        var documentId = decodeURIComponent(window.location.search.substring(1));
        console.log('getPublicUserDocumentList', window.location, documentId);
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'GetCandidatePublicCertificates', {
            PublicUrl: documentId
        }, null, new DocumentList());
    };
    DocumentServices.prototype.getAllOrPublicUserDocumentList = function () {
        if (process.env.RECIPIENT_ADMIN) {
            return this.getAllUserDocumentList();
        }
        else {
            return this.getPublicUserDocumentList();
        }
    };
    DocumentServices.prototype.updateDocumentVisibility = function (documentId, isVisible) {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'UpdateDocumentVisibility', {
            DigitalDiplomaFileId: documentId,
            IsVisible: isVisible
        });
    };
    DocumentServices.prototype.signDocument = function (documentId) {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'StudentSignatureApproved', {
            DigitalDiplomaFileId: documentId
        });
    };
    return DocumentServices;
}(ServiceBase));
export { DocumentServices };
export var documentServices = new DocumentServices();



//////////////////
// WEBPACK FOOTER
// ./src/modules/documents/services/DocumentServices.ts
// module id = null
// module chunks = 